import styled, { css } from 'styled-components';
import Reveal from './reveal';
import { Eyebrow, Lead, SectionTitle } from './typography';

const Container = styled(Reveal)`
  max-width: 768px;

  ${({ $align }) =>
    $align === 'center' &&
    css`
      margin-left: auto;
      margin-right: auto;
      text-align: center;
    `};
`;

const Title = styled(SectionTitle)`
  ${({ $spaced }) =>
    $spaced &&
    css`
      margin-top: 12px;
    `};
`;

const Description = styled(Lead)`
  margin-top: 16px;
`;

/**
 * Eyebrow + heading + description block used at the top of sections.
 *
 *   <SectionHeader
 *     eyebrow="How it works"
 *     title="Gift cards in three steps"
 *     description="Pick a brand, pay, and get your code by email."
 *     align="center"
 *   />
 *
 * `as` sets the heading level ('h1' | 'h2' | 'h3', default 'h2').
 */
const SectionHeader = ({ align = 'left', as = 'h2', className, description, eyebrow, title }) => (
  <Container $align={align} className={className}>
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <Title as={as} $spaced={Boolean(eyebrow)}>
      {title}
    </Title>
    {description && <Description>{description}</Description>}
  </Container>
);

export default SectionHeader;
